import { LegacySelect } from "@powerledger/ui-component-lib";
import { useTranslation } from "react-i18next";

import { getSelectTranslation } from "@/app/lib/get-translations-for-components";
import { RegistryLinkStatus } from "@/app/types/generated/graphql";

import { RegistryDropdownViewProps } from "./registry-dropdown.types";

export const RegistryDropdownView = ({
  sx = {},
  disabled = false,
  loading,
  registries,
  activeRegistry,
  disabledRegistries,
  onActiveRegistryChange,
}: RegistryDropdownViewProps) => {
  const { t } = useTranslation();

  return (
    <LegacySelect
      sx={{
        width: "100%",
        ...sx,
      }}
      isLoading={loading}
      value={activeRegistry}
      options={registries ?? []}
      translation={getSelectTranslation(t)}
      getOptionLabel={(registry) => registry.shortName}
      getOptionValue={(registry) => registry.registryId}
      onChange={(registry) => onActiveRegistryChange(registry ?? null)}
      isOptionDisabled={(registry) =>
        registry.status !== RegistryLinkStatus.Registered ||
        Boolean(disabledRegistries?.some((disabledRegistry) => disabledRegistry.registryId === registry.registryId))
      }
      testid="registry-selection-dropdown"
      disabled={disabled}
    />
  );
};
